export default "__VITE_ASSET__DPA4Mbmy__"